module.exports = __webpack_public_path__ + "style/img/Group 2155.9a26d816.png";